import { mapToList } from '../../utils/transform';
import { types as actions } from '../actions';

const defaultState = {
  map: {},
  list: []
};

export default (state = defaultState, action = {}) => {
  switch (action.type) {
    case actions.ADDED_ZONE: {
      let zones =
        action.zone.area.id in state.map ? state.map[action.zone.area.id] : [];
      zones.push(action.zone);
      let map = {
        ...state.map,
        [action.zone.area.id]: zones
      };
      return {
        map,
        list: mapToList(map)
      };
    }
    case actions.SET_ZONES: {
      let map = {
        ...state.map,
        [action.areaId]: action.zones
      };
      return {
        map,
        list: mapToList(map)
      };
    }
    case actions.REMOVE_ZONE: {
      let zoneId = action.zone.zoneId;
      let areaId = action.zone.areaId;
      let zones = state.map[areaId].filter(zone => zone.id !== zoneId);
      let map = {
        ...state.map,
        [areaId]: zones
      };
      return {
        map,
        list: mapToList(map)
      };
    }
    case actions.GET_AREAS:
      return {
        ...defaultState
      };
    case actions.SET_ZONES_BY_SITE: {
      let zones = action.zones.reduce((map, zone) => {
        let areaId = zone.area.id;
        if (areaId in map) {
          map[areaId].push(zone);
        } else {
          map[areaId] = [zone];
        }
        return map;
      }, {});
      return {
        map: zones,
        list: action.zones
      };
    }
    case actions.EDITED_ZONE: {
      let zoneId = action.zone.id;
      let areaId = action.zone.area.id;
      let zones = state.map[areaId].map(zone => {
        if(zone.id === zoneId){
          zone = action.zone;
        }
        return zone;
      });
      let map = {
        ...state.map,
        [areaId]: zones
      };
      return {
        map,
        list: mapToList(map)
      };
    }
    case actions.LOGGED_OUT:
      return defaultState;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/zones/index.js